import React, { useEffect, useMemo, useState } from 'react'
import { Redirect, useLocation } from 'react-router-dom'
import { compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { setUser } from '@sentry/react'
import axios from 'axios'

const CheckAuth = ({ auth, children, location }) => {
  const [redirectTo, setRedirectTo] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const { search } = useLocation()
  const query = useMemo(() => {
    return new URLSearchParams(search)
  }, [search])

  setUser({
    id: auth?.user?.uuid || null,
    ip_address: '{{auto}}',
  })

  if (auth.token) {
    return children
  }

  // @fixme: useEffect should be at the very top before IF to avoid rendering errors
  // @fixme: useEffect should depends on auth changes
  useEffect(() => {
    if (!auth.token) {
      const clubUuidFromUrl = query.get('club') || null

      if (clubUuidFromUrl) {
        // Fetch club's public data to determine SSO redirect  or fallback to /login
        setIsLoading(true)
        axios
          .get(
            `${process.env.REACT_APP_API_ENDPOINT}/v2/clubs/${clubUuidFromUrl}/public?include=organization.ssoProviders`
          )
          .then((response) => {
            const club = response.data.data
            const ssoProviders = club?.relationships?.organization?.relationships?.sso_providers

            if (!Array.isArray(ssoProviders) || ssoProviders.length === 0) {
              setRedirectTo('/login')
              return
            }

            if (ssoProviders.some((p) => p.slug === 'cfg')) {
              setRedirectTo('/cfg')
            } else if (ssoProviders.some((p) => p.slug === 'bmg')) {
              setRedirectTo('/bmg')
            } else if (ssoProviders.some((p) => p.slug === 'bvb-nlz')) {
              setRedirectTo('/bvb-nlz')
            } else {
              setRedirectTo('/login')
            }
          })
          .catch(() => {
            setRedirectTo('/login')
          })
          .finally(() => {
            setIsLoading(false)
          })
      } else {
        setRedirectTo('/login')
      }
    }
  }, [])

  if (isLoading) {
    return null
  }

  if (redirectTo) {
    return (
      <Redirect
        to={{ pathname: redirectTo, fromPathname: location.pathname }}
      />
    )
  }

  return null // Prevent rendering issues
}

CheckAuth.defaultProps = {
  location: {
    pathname: '/',
  },
}

CheckAuth.propTypes = {
  auth: PropTypes.shape().isRequired,
  children: PropTypes.node.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }),
}

export default compose(
  connect(({ auth }) => ({
    auth,
  }))
)(CheckAuth)
